<template>

  <span>
    <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
              <div class="flex items-center justify-between con-btns-user">
                <div class="flex items-center justify-start con-userx">
                  <vs-avatar color="primary" :text="customer.company_name"/>
                  <span class="font-semibold text-primary">{{ customer.company_name }}( {{
                      customer.account_number
                    }} ) </span>

                   <vs-chip size="small" class="ml-2" transparent color="#7952B3">
                      {{ customer.account_currency }}
                    </vs-chip>

                </div>
                <div class="flex items-center">
                  <div class="flex items-center mr-4">
                    <span class="mr-2 text-sm font-semibold">OTIF Tracked:</span>
                    <vs-switch v-model="customer.is_otif_tracked" @input="onChangeOtifTracker" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="w-16">
                      <span slot="on">Yes</span>
                      <span slot="off">No</span>
                    </vs-switch>
                  </div>
                  <vs-button @click.stop="onClickChangeCustomerCurrency" icon-pack="feather" icon="icon-dollar-sign" type="border" size="small">Change Currency</vs-button>
                  <vs-button v-if="$canAny(['view-customer', 'sales-crm-access'])" @click.stop="onClickViewCustomerLogs" icon-pack="feather" icon="icon-list" color="warning" type="border" size="small" class="ml-2">Activity Logs</vs-button>
                </div>
              </div>
            </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full vx-col" v-if="is_load">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                 id="profile-tabs" :key="isSmallerScreen">

            <vs-tab icon-pack="feather" icon="icon-file" v-if="$canAny(['view-customer', 'sales-crm-access'])"
                    :label="!isSmallerScreen ? 'Profile' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-profile-details-view v-on:refreshData="fetchCustomer"/>
              </div>
            </vs-tab>
            <vs-tab active v-if="$canAny(['view-customer-users','create-edit-customer-users'])"
                    icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Users' : ''">
              <div class="mt-4 ml-0 tab-change-pwd md:ml-4 md:mt-0">
                <customer-users-list :sage_id="customer.sage_id"/>
              </div>
            </vs-tab>
            <vs-tab v-if="$canAny(['view-site','create-edit-site'])" active icon-pack="feather" icon="icon-circle"
                    :label="!isSmallerScreen ? 'Sites' : ''">
              <div class="mt-4 ml-0 tab-change-pwd md:ml-4 md:mt-0">
                <customer-sites-list/>
              </div>
            </vs-tab>
            <vs-tab active icon-pack="feather" icon="icon-lock" v-if="$canAny(['view-private-formulation','edit-private-formulation','create-private-formulation'])"
                    :label="!isSmallerScreen ? 'Bespoke Formulation' : ''">
              <div class="mt-4 ml-0 tab-change-pwd md:ml-4 md:mt-0">
                <customer-private-formulation-list/>
              </div>
            </vs-tab>
            <vs-tab active v-if="$canAny(['view-project-brief','create-edit-project-brief'])"
                    icon-pack="feather" icon="icon-briefcase" :label="!isSmallerScreen ? 'Project Brief' : ''">
              <div class="mt-4 ml-0 tab-change-pwd md:ml-4 md:mt-0">
                <customer-project-brief-list/>
              </div>
            </vs-tab>
            <vs-tab v-if="$canAny(['view-account-credit','create-edit-account-credit'])" icon-pack="feather"
                    icon="icon-dollar-sign" :label="!isSmallerScreen ? 'Account Credit' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-account-credit-home v-bind:account_currency="customer.account_currency"/>
              </div>
            </vs-tab>
            <vs-tab v-if="$canAny(['view-credit-note','create-edit-credit-note','link-credit-note']) && [7, 9, 10, 11, 12].includes(customer.status.id)" 
                    icon-pack="feather" icon="icon-edit" :label="!isSmallerScreen ? 'Credit Note' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-credit-note-list v-bind:account_currency="customer.account_currency"/>
              </div>
            </vs-tab>
            <vs-tab v-if="$canAny(['view-sample-order','create-edit-sample-order'])" icon-pack="feather"
                    icon="icon-shopping-cart" :label="!isSmallerScreen ? 'Sample Orders' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-sample-orders-list/>
              </div>
            </vs-tab>
            <vs-tab v-if="$canAny(['view-order','create-edit-order']) && [7, 9, 10, 11, 12].includes(customer.status.id)" icon-pack="feather" icon="icon-box"
                    :label="!isSmallerScreen ? 'Sales Orders' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-product-orders-list v-bind:account_currency="customer.account_currency"
                v-bind:customer_stage="customer.stage"/>
              </div>
            </vs-tab>
            <vs-tab v-if="$canAny(['view-product-contract','create-edit-product-contract'])"
                    icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? 'Contract Pricing' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-product-contracts v-bind:account_currency="customer.account_currency"/>
              </div>
            </vs-tab>
            <vs-tab v-if="$canAny(['view-bespoke-pricing','create-edit-bespoke-pricing'])" icon-pack="feather"
                    icon="icon-tag" :label="!isSmallerScreen ? 'Bespoke Pricing' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-bespoke-price-list v-bind:account_currency="customer.account_currency"/>
              </div>
            </vs-tab>

            <vs-tab icon-pack="feather" v-if="$canAny(['view-product-name-mapping','create-edit-product-name-mapping'])"
                    icon="icon-hash" :label="!isSmallerScreen ? 'Product Name Mapping' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-product-details-list/>
              </div>
            </vs-tab>
          <vs-tab icon-pack="feather" v-if="$canAny(['create-edit-sales-quote', 'view-sales-quote'])"
                    icon="icon-layout" :label="!isSmallerScreen ? 'Sales Quote' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <sales-quote-list/>
              </div>
            </vs-tab>
            <vs-tab icon-pack="feather" v-if="$canAny(['sales-crm-access'])"
                    icon="icon-layout" :label="!isSmallerScreen ? 'CRM' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-crm-home v-bind:account_currency="customer.account_currency"/>
              </div>
            </vs-tab> 
            <vs-tab icon-pack="feather" v-if="$canAny(['view-forecast-tool'])"
                    icon="icon-globe" :label="!isSmallerScreen ? 'Forecast Tool' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <customer-forecast-tool v-bind:customer="customer"/>
              </div>
            </vs-tab>        
           </vs-tabs>
      </div>
    </div>
    <UpdateCustomerCurrencyPopUp ref="updateCustomerCurrencyPopUp" v-on:refreshData="fetchCustomer()"/>
    <ViewCustomerLogPopUp ref="viewCustomerLogPopUp"/>
  </span>
</template>

<script>
import CustomerProfileDetailsView from './CustomerProfileDetailsView.vue'
import CustomerSitesList from './CustomerSitesList.vue'
import CustomerUsersList from './CustomerUsersList.vue'
import CustomerProjectBriefList from './CustomerProjectBriefList.vue'
import CustomerAccountCreditHome from './CustomerAccountCreditHome.vue'
import CustomerSampleOrdersList from './samples/sample-orders/CustomerSampleOrdersList.vue'
import CustomerCartList from './samples/sample-orders/CustomerCartList.vue'
import CustomerProductContracts from './samples/product-contracts/CustomerProductContracts.vue'
import CustomerProductOrdersList from './product-orders/CustomerProductOrdersList.vue'
import CustomerBespokePriceList from './bespoke-price/CustomerBespokePriceList.vue'
import {RepositoryFactory} from '@/repository/RepositoryFactory';
import CustomerPrivateFormulationList
  from "@/views/pages/customer-manage/CustomerDetailsGeneral/CustomerPrivateFormulationList";
import CustomerCreditNoteList from "@/views/pages/customer-manage/CustomerDetailsGeneral/CustomerCreditNoteList";
import CustomerProductDetailsList
  from "@/views/pages/customer-manage/CustomerDetailsGeneral/product-details/CustomerProductDetailsList";
import SalesQuoteList from "@/views/pages/sales-quote/SalesQuoteList";
import CustomerCrmHome from './CRM/CustomerCrmHome.vue'
import CustomerForecastTool from './customer-forecast/CustomerForecastTool.vue'
import UpdateCustomerCurrencyPopUp from '@/components/popups/customer/customer-currency/UpdateCustomerCurrencyPopUp.vue'
import ViewCustomerLogPopUp from '@/components/popups/customer/ViewCustomerLogPopUp.vue'
import ErrorMessages from '@/mixins/ErrorMessages'

const CustomerRepository = RepositoryFactory.get('customer')

export default {
  mixins: [ErrorMessages],
  components: {
    CustomerProfileDetailsView,
    CustomerUsersList,
    CustomerSitesList,
    CustomerProjectBriefList,
    CustomerAccountCreditHome,
    CustomerSampleOrdersList,
    CustomerCartList,
    CustomerProductContracts,
    CustomerProductOrdersList,
    CustomerBespokePriceList,
    CustomerPrivateFormulationList,
    CustomerCreditNoteList,
    CustomerProductDetailsList,
    SalesQuoteList,
    CustomerCrmHome,
    CustomerForecastTool,
    UpdateCustomerCurrencyPopUp,
    ViewCustomerLogPopUp,
  },
  data() {
    return {
      active_step: this.$route.query.step ? this.$route.query.step : '0',
      customerId: '',
      customer: {
        status: {
          id: 7
        },
        is_otif_tracked: false
      },
      is_load: true
    }
  },
  async mounted() {
    this.customerId = this.$route.params.id
    await this.fetchCustomer()
    if (this.$route.query.tab === 'contract') {
      this.$nextTick(() => {
        this.active_step = String(this.contractPricingTabIndex)
      })
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    },
    contractPricingTabIndex() {
      let index = 0
      if (this.$canAny(['view-customer', 'sales-crm-access'])) index++
      if (this.$canAny(['view-customer-users', 'create-edit-customer-users'])) index++
      if (this.$canAny(['view-site', 'create-edit-site'])) index++
      if (this.$canAny(['view-private-formulation', 'edit-private-formulation', 'create-private-formulation'])) index++
      if (this.$canAny(['view-project-brief', 'create-edit-project-brief'])) index++
      if (this.$canAny(['view-account-credit', 'create-edit-account-credit'])) index++
      if (this.$canAny(['view-credit-note', 'create-edit-credit-note', 'link-credit-note']) && [7, 9, 10, 11, 12].includes(this.customer.status.id)) index++
      if (this.$canAny(['view-sample-order', 'create-edit-sample-order'])) index++
      if (this.$canAny(['view-order', 'create-edit-order']) && [7, 9, 10, 11, 12].includes(this.customer.status.id)) index++
      return index
    }
  },
  methods: {
    async fetchCustomer() {
      this.is_load = !this.is_load
      try {
        const {data} = (await CustomerRepository.getCustomerDetails(this.customerId)).data;
        if (data) {
          data.is_otif_tracked = !!data.is_otif_tracked
        }
        this.customer = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.is_load = !this.is_load
    },
    async onChangeOtifTracker(val) {
      this.$vs.loading({
        container: '#customer_details',
        scale: 0.45
      })
      try {
        const isTracked = !!val
        await CustomerRepository.updateOtifTracker(this.customerId, { is_otif_tracked: isTracked })
        this.$vs.notify({
          title: 'Success',
          text: 'OTIF tracker updated successfully',
          color: 'success',
          position: 'top-right'
        })
        await this.fetchCustomer()
      } catch (e) {
        this.customer.is_otif_tracked = !val
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close('#customer_details > .con-vs-loading')
      }
    },
    async onClickChangeCustomerCurrency(){
      await this.$refs.updateCustomerCurrencyPopUp.openPopup(this.customerId, this.customer.account_currency)
    },
    async onClickViewCustomerLogs() {
      await this.$refs.viewCustomerLogPopUp.openPopup(this.customerId, this.customer.company_name)
    }
  },
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
